import React, { useState, useEffect, useCallback, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Popup from 'reactjs-popup';
import CompanyRequestItem from './CompanyRequestItem';
import Confirmation from '../../common/Confirmation';
import { CompanyService } from './../../../service/company.service'
import Alert from '../../common/Alert';

import '../../../../node_modules/reactjs-popup/dist/index.css';
import '../../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const CompanyRequest = () => {
    const gridRef = useRef();
    const [rowData, setRowData] = useState();
    const [loading, setLoading] = useState(true);
    const [isAlert, setIsAlert] = useState(false);

    const companyService = new CompanyService();

    const gridCellRenderer = (params) => {
        if (params.value) {
            let _value = '<span title="' + params.value + '">' + params.value + '</span>';
            return <div dangerouslySetInnerHTML={{ __html: _value }}></div>;;
        }
    }

    const detailsCellRenderer = (params) => {
        let html = '<a title="Edit User" style="color:#007bff;"><i class="fa fa-edit"></i></a>';
        return <Popup trigger={<div dangerouslySetInnerHTML={{ __html: html }}></div>} nested modal>{close => (<CompanyRequestItem data={params.data} onClose={() => { close(); }}></CompanyRequestItem>)}</Popup>;
    };

    const deleteCellRenderer = (params) => {
        return <Popup trigger={<i className="fa fa-trash"></i>} nested modal>{close => (<Confirmation message="Are you sure you want to delete this company request?" data={params.data.id} onSuccess={onSuccess} onClose={() => { close(); }}></Confirmation>)}</Popup>
    }

    const columnDefs = [
        { headerName: 'Name', field: 'name', width: 300, filter: true, cellRenderer: p => gridCellRenderer(p), resizable: false },
        { headerName: 'Requestor Name', field: 'requestorName', filter: false, width: 350, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Requestor Email', field: 'requestorEmail', width: 350, filter: false, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: '', colId: 'details-button', field: '', width: 30, sortable: false, cellRenderer: p => detailsCellRenderer(p), resizable: false },
        { headerName: '', colId: 'delete-button', field: '', width: 50, suppressSizeToFit: true, sortable: false, cellRenderer: p => deleteCellRenderer(p), resizable: true }
    ];

    useEffect(() => {
        fetch('/api/companyrequest/getallrequest')
            .then(result => result.json())
            .then(rowData => {
                setRowData(rowData.data);
                setLoading(false);
                gridRef.current.api.sizeColumnsToFit();
            })
    }, [loading]);

    const onSuccess = async (id) => {
        const result = await companyService.deleteCompanyRequest(id);
        if (result.status == 200 && result.data.isSuccess) {
            setIsAlert(true);
            setLoading(true);
        }
    };
        
    const alertOff = () => {
        setIsAlert(false);
    };

    const gridOptions = {
        columnDefs: columnDefs,
        pagination: true,
        rowSelection: 'single',
        enableFilter: true,
        cacheBlockSize: 25,
        paginationPageSize: 25,
        getRowHeight: (params) => 25
    }

    return (
        <div className="card">
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> Company Request
            </h5>
            <div className="card-body" style={{ height: "75vh" }}>
                {isAlert && <div><Alert type="error" message={"Company request deleted successfully"} callBack={alertOff} /></div>}
                <div className="ag-theme-alpine" style={{ height: "100%"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        gridOptions={gridOptions} />
                </div>
            </div>
        </div>
    );
};

export default CompanyRequest;